// Javascript implementation for checking
// Highly Composite Number

// Function to count the number
// of divisors of the N
export const divCount = (num: number) => {
  // sieve method for prime calculation
  let hash = Array(num + 1).fill(true);

  for (let prime = 2; prime * prime < num; prime++)
    if (hash[prime]) {
      for (let i = prime * 2; i < num; i += prime) {
        hash[i] = false;
      }
    }

  // Traversing through
  // all prime numbers
  let total = 1;
  for (let prime = 2; prime <= num; prime++) {
    if (hash[prime]) {
      // calculate number of divisor
      // with formula total div =
      // (p1+1) * (p2+1) *.....* (pn+1)
      // where n = (a1^p1)*(a2^p2)....
      // *(an^pn) ai being prime divisor
      // for n and pi are their respective
      // power in factorization
      let count = 0;
      if (num % prime == 0) {
        while (num % prime == 0) {
          num = num / prime;
          count++;
        }
        total = total * (count + 1);
      }
    }
  }
  return total;
}

// Function to check if a number
// is a highly composite number
export const isHighlyComposite = (num: number) => {
  // count number of factors of N
  let NdivCount = divCount(num);

  // loop to count number of factors of
  // every number less than N
  for (let i = 1; i < num; i++) {
    let idivCount = divCount(i);

    // If any number less than N has
    // more factors than N,
    // then return false
    if (idivCount >= NdivCount) return false;
  }
  return true;
}